import {
  REACT_APP_SEARCH_DETAILS_ACQUISITION_URL,
  REACT_APP_SEARCH_DETAILS_AGILE_PURCHASE_PUBLIC,
  REACT_APP_SEARCH_DETAILS_DIRECT_DEAL_URL,
  REACT_APP_SEARCH_DETAILS_GREAT_PURCHASE_URL,
  REACT_APP_SEARCH_DETAILS_PURCHASE_ORDER_URL
} from './environment'

export const DISABLED_CONTRACT_TEXT = 'INHABILITADO PARA CONTRATAR CON EL ESTADO'

export const USER_TYPE = {
  SELLER: 'Proveedor',
  BUYER: 'Comprador',
  PUBLIC: 'Publico'
}

export const GENERAL_INFORMATION_TABS = {
  GENERAL_INFORMATION: {
    SERVICE_ERROR:
      'No ha sido posible obtener información de la institución.\nPor favor, te pedimos que lo vuelvas a intentar dentro de unos minutos.'
  },
  DEPENDENT_BUYER_STATUS: {
    NO_DATA: 'La institución no cuenta con organismos compradores dependientes',
    SERVICE_ERROR: 'Sin información'
  },
  AUTHORITIES: {
    NO_REPRESENTATIVE_AUTHORITY: 'La institución no ha declarado su autoridad representante',
    SERVICE_ERROR: 'Sin información'
  }
}

export const ANNUAL_PURCHASE_PLAN_TABS = {
  SERVICE_ERROR: `No ha sido posible obtener información de la institución.\nPor favor, te pedimos que lo vuelvas a intentar dentro de unos minutos.`,
  NO_INFO: 'No existe información',
  ANNUAL_PURCHASE_PLAN_EXECUTION: {
    NO_DATA: 'El organismo comprador no cuenta con información de su Plan Anual de Compras'
  },
  ANNUAL_PURCHASE_PLAN_OUTSIDE: {
    NO_DATA: 'El organismo comprador no cuenta con órdenes de compra fuera de su Plan Anual de Compras'
  },
  DATA_CHART: {
    COLORS: {
      PLANNED: '#D81A60',
      EXECUTED: '#303F9F'
    },
    FOOTER: {
      PLANNED: 'Monto planificado para el mes',
      EXECUTED: 'Monto ejecutado en el mes'
    }
  },
  DOWNLOAD_FILE_NAME: 'Plan Anual de Compra'
}

export const CLAIMS_OPTIONS_DICTIONARY = {
  all: -1,
  paymentNotTime: 1,
  irregularity: 2
}

export const CLAIMS_OPTIONS = [
  { name: 'Irregularidad en el proceso de compra', value: CLAIMS_OPTIONS_DICTIONARY.irregularity },
  { name: 'Pago no oportuno', value: CLAIMS_OPTIONS_DICTIONARY.paymentNotTime },
  { name: 'Todas', value: CLAIMS_OPTIONS_DICTIONARY.all }
]

export const MONTHS = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre'
]

export const DEFAULT_MONTHS_OPTIONS = MONTHS.map((month, index) => ({ name: month.toLocaleUpperCase(), value: index }))

export const DEFAULT_YEARS_OPTIONS = [
  { name: '2024', value: 2024 },
  { name: '2025', value: 2025 },
  { name: '2026', value: 2026 }
]

export const DEFAULT_DIMENTIONS_OPTIONS = [
  {
    name: 'Participación de proveedores en Mercado Público',
    value: 1
  },
  {
    name: 'Procedimientos de compra',
    value: 2
  },
  {
    name: 'Eficiencia en los procesos',
    value: 3
  },
  {
    name: 'Buenas prácticas',
    value: 4
  },
  {
    name: 'Normativa',
    value: 5
  }
]

export const INITIAL_CLAIM_TABLE = [
  {
    fechaDeIngreso: '',
    idReclamo: '',
    procesoReclamado: '',
    reclamante: '',
    tipoDeReclamo: ''
  }
]

export const MECHANISM_DICTIONARY = {
  CA: {
    encryption: false,
    name: 'COMPRA AGIL',
    url: `${REACT_APP_SEARCH_DETAILS_AGILE_PURCHASE_PUBLIC}?code={mechanismCode}`
  },
  GC: {
    encryption: true,
    name: 'GRAN COMPRA',
    url: `${REACT_APP_SEARCH_DETAILS_GREAT_PURCHASE_URL}?IURL={id}`
  },
  LIC: {
    encryption: false,
    name: 'LICITACION',
    url: `${REACT_APP_SEARCH_DETAILS_ACQUISITION_URL}?idlicitacion={mechanismCode}`
  },
  OC: {
    encryption: false,
    name: 'ORDEN DE COMPRA',
    url: `${REACT_APP_SEARCH_DETAILS_PURCHASE_ORDER_URL}?codigooc={mechanismCode}`
  },
  TD: {
    encryption: false,
    name: 'TRATO DIRECTO',
    url: `${REACT_APP_SEARCH_DETAILS_DIRECT_DEAL_URL}/{mechanismCode}`
  },
  Indefinido: {
    encryption: false,
    name: 'Indefinido',
    url: null
  }
}

export const BEHAVIOR_INDICATOR_FILE = 'detalle-indicadores-igc.pdf'
export const GESTION_TITLE = 'Índice de Gestión'
